import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { styled } from "@mui/material";
import React from "react";

const CustomMenuItem = styled("div", {
  shouldForwardProp: (prop) =>
    prop !== "isCollapsed" && prop !== "isActive" && prop !== "isSubmenuOpen",
})(({ isCollapsed, isActive, isSubmenuOpen }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: isCollapsed ? "center" : "flex-start",
  height: "50px",
  marginBottom: "10px",
  textDecoration: "none",
  color: isActive ?  "#119bab":"white",
  backgroundColor: isActive ?  "white":"#119bab",
  boxSizing: "border-box",
  cursor: "pointer",
  padding: isCollapsed ? "0" : "0px 5px",
  // boxShadow: isCollapsed ? "none" : "0px 4px 6px rgba(0, 0, 0, 0.1)",
  borderRadius: "8px",
  borderLeft: isActive ? "4px solid #119bab" : "4px solid transparent",
  "& .menuText": {
    display: isCollapsed ? "none" : "inline",
  },

  "& .arrowIcon": {
    marginLeft: "auto",
    transition: "transform 0.3s ease-in-out",
    transform: isSubmenuOpen ? "rotate(0deg)" : "rotate(0deg)",
  },
}));


const CustomMenuItemComponent = ({
  icon,
  isCollapsed,
  isActive,
  isSubmenuOpen,
  children,
  onClick,
  hasSubmenu,
}) => {
  return (
    <CustomMenuItem
      isCollapsed={isCollapsed}
      isActive={isActive}
      isSubmenuOpen={isSubmenuOpen}
      onClick={onClick}
    >
      {icon && <div style={{ marginRight: "10px" }}>{icon}</div>}
      <span className="menuText">{children}</span>
      {hasSubmenu && !isCollapsed && (
        <div className="arrowIcon">
          {isSubmenuOpen ? <KeyboardArrowDownIcon /> : <ChevronRightIcon />}
        </div>
      )}
    </CustomMenuItem>
  );
};

export default CustomMenuItemComponent;
